import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top of the viewport on every route change (React Router
// doesn't do this by default — otherwise navigating from a scrolled page keeps
// the scroll position on the new page).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use "instant" so navigation feels snappy; "auto" behaves similarly.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (_) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
